import { render } from "./GrowthContainer.vue?vue&type=template&id=608e63ee&scoped=true"
import script from "./GrowthContainer.vue?vue&type=script&lang=js"
export * from "./GrowthContainer.vue?vue&type=script&lang=js"

import "./GrowthContainer.vue?vue&type=style&index=0&id=608e63ee&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-608e63ee"]])

export default __exports__